/** Canonical labels for courier package returns (Vraćeni paketi).
 *  Single source of truth shared by the module page and the COD list. */

export const RETURN_REASONS = [
  "refused",
  "wrong_address",
  "wrong_phone",
  "not_picked_up",
  "damaged",
  "lost",
  "other",
] as const;

export type PackageReturnReason = (typeof RETURN_REASONS)[number];

export const RETURN_REASON_LABEL: Record<PackageReturnReason, string> = {
  refused: "Odbio preuzeti",
  wrong_address: "Netačna adresa",
  wrong_phone: "Pogrešan broj telefona",
  not_picked_up: "Nije podignuto",
  damaged: "Oštećeno",
  lost: "Izgubljen",
  other: "Drugo",
};

/** Translucent badge styling used in list/table views. */
export const RETURN_REASON_BADGE: Record<PackageReturnReason, string> = {
  refused: "bg-red-500/15 text-red-400 border-red-500/20",
  wrong_address: "bg-orange-500/15 text-orange-400 border-orange-500/20",
  wrong_phone: "bg-sky-500/15 text-sky-400 border-sky-500/20",
  not_picked_up: "bg-amber-500/15 text-amber-400 border-amber-500/20",
  damaged: "bg-violet-500/15 text-violet-400 border-violet-500/20",
  lost: "bg-rose-500/15 text-rose-400 border-rose-500/20",
  other: "bg-slate-500/15 text-slate-400 border-slate-500/20",
};

/** Ishod automatskog otkazivanja narudžbe pri evidentiranju vraćenog paketa. */
export const CANCEL_STATUSES = [
  "cancelled",
  "already_cancelled",
  "skipped_paid",
  "skipped_unlinked",
  "failed",
] as const;

export type ReturnCancelStatus = (typeof CANCEL_STATUSES)[number];

export const CANCEL_STATUS_LABEL: Record<ReturnCancelStatus, string> = {
  cancelled: "Narudžba otkazana",
  already_cancelled: "Već otkazana",
  skipped_paid: "Plaćena — nije otkazana",
  skipped_unlinked: "Bez narudžbe",
  failed: "Otkazivanje nije uspjelo",
};

export const CANCEL_STATUS_BADGE: Record<ReturnCancelStatus, string> = {
  cancelled: "bg-emerald-500/15 text-emerald-400 border-emerald-500/20",
  already_cancelled: "bg-slate-500/15 text-slate-400 border-slate-500/20",
  skipped_paid: "bg-amber-500/15 text-amber-400 border-amber-500/20",
  skipped_unlinked: "bg-slate-500/15 text-slate-400 border-slate-500/20",
  failed: "bg-red-500/15 text-red-400 border-red-500/20",
};

/** Statusi koje operater može ručno ponoviti/forsirati iz tabele. */
export function canRetryCancel(status: string): boolean {
  return status === "failed" || status === "skipped_paid";
}

/** Solid dot color for stat cards; keep hues in sync with RETURN_REASON_BADGE. */
export const RETURN_REASON_DOT: Record<PackageReturnReason, string> = {
  refused: "bg-red-400",
  wrong_address: "bg-orange-400",
  wrong_phone: "bg-sky-400",
  not_picked_up: "bg-amber-400",
  damaged: "bg-violet-400",
  lost: "bg-rose-400",
  other: "bg-slate-400",
};
